export default "__VITE_ASSET__C2aMu76u__"